// extracted by mini-css-extract-plugin
export var color = "cart-upsell-module--color--a18e9";
export var image = "cart-upsell-module--image--eb2b4";
export var img = "cart-upsell-module--img--d6d0a";
export var price = "cart-upsell-module--price--70330";
export var rec = "cart-upsell-module--rec--d53ca";
export var rec_content = "cart-upsell-module--rec_content--bf333";
export var rec_image = "cart-upsell-module--rec_image--56976";
export var recs = "cart-upsell-module--recs--f55be";
export var recs_head = "cart-upsell-module--recs_head--24963";
export var title = "cart-upsell-module--title--5b563";
export var title_price = "cart-upsell-module--title_price--a4aa6";
export var upsell = "cart-upsell-module--upsell--c2d0a";